import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
// import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin, signOut } from '../../auth/Auth';
import { getShops } from '../../actions/Shop';
import { getGroupDetail } from '../../actions/Groups';
import { getAccounts } from '../../actions/Accounts';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import EmailChangeGroup from '../organisms/EmailChangeGroup';
import PasswordChangeGroup from '../organisms/PasswordChangeGroup';

const styles = theme => ({
  root: {
    // backgroundColor: '#e0e0e0',
    // flexGrow: 1,
    // width: '100%'
    display: 'flex'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: 'calc(100% - 240px)'
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  mainPaper: {
    position: 'relative',
    margin: '20px 0',
    minWidth: 500
  },
  buttonsWrapper: {
    padding: '20px 0'
  },
  divCenter: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: 20
  },
  button: {
    fontSize: 14,
    fontWeight: 'bold',
    padding: '10px 0',
    margin: '0 auto',
    width: '30.3%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      shops: state.shops.shops,
      totalCount: state.shops.totalCount,
      limit: state.shops.limit,
      groupDetail: state.groups.detail
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getShops, getGroupDetail, getAccounts },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openGroupChangeMail', 'updateOpenGroupChangeMail', false),
  withState('openGroupChangePassword', 'updateOpenGroupChangePassword', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
    }
  })
);

const Main = enhance(
  ({
    classes,
    loading,
    openProgress, // account,
    handleRedirect,
    openGroupChangeMail,
    updateOpenGroupChangeMail,
    openGroupChangePassword,
    updateOpenGroupChangePassword,
    account
  }) => {
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;

    const openChangeMail = () => {
      updateOpenGroupChangeMail(true);
    };

    const openChangePassword = () => {
      updateOpenGroupChangePassword(true);
    };

    const openSuspensionUse = () => {
      window.open('https://support.gigi.tokyo/contact/close/');
    };

    const openSupportSite = () => {
      window.open('https://support.gochimeshi.com/s/');
    };

    const openInquiry = () => {
      window.open('https://support.gigi.tokyo/contact/contact01/');
    };

    const handleLogout = async () => {
      signOut();
      handleRedirect('/');
    };

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="設定" />
        <main className={classes.content}>
          <Typography variant="h6" noWrap className={classes.title}>
            設定
          </Typography>
          <Paper className={classes.mainPaper} elevation={1}>
            <div className={classes.buttonsWrapper}>
              <div className={classes.divCenter}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={openChangeMail}
                >
                  メールアドレス変更
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={openChangePassword}
                >
                  パスワード変更
                </Button>
                {!isFukuoka && (
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={openSuspensionUse}
                  >
                    利用停止
                  </Button>
                )}
              </div>
              {!isFukuoka && (
                <div className={classes.divCenter}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={openSupportSite}
                  >
                    サポートサイト
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={openInquiry}
                  >
                    問い合わせ
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={handleLogout}
                  >
                    ログアウト
                  </Button>
                </div>
              )}
            </div>
          </Paper>
          <div>
            <Modal open={openGroupChangeMail} className={classes.mainModal}>
              <EmailChangeGroup
                updateOpenGroupChangeMail={updateOpenGroupChangeMail}
              />
            </Modal>
            <Modal open={openGroupChangePassword} className={classes.mainModal}>
              <PasswordChangeGroup
                updateOpenGroupChangePassword={updateOpenGroupChangePassword}
              />
            </Modal>
          </div>
        </main>

        <ProgressDialog openProgress={openProgress} loading={loading} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
